import styled from 'styled-components';

import Button from '@bufferapp/ui/Button';
import Text from '@bufferapp/ui/Text';

export const ModalWrapperStyled = styled.div`
  padding: 20px 24px 20px 24px;
  width: 514px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const ParagraphStyled = styled(Text)`
  margin-top: 0;
  margin-bottom: 2.25rem;
`;

export const ModalActionsStyled = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const TitleStyled = styled(Text)`
  margin-bottom: 16px;
  margin-top: 0;
`;

export const ButtonStyled = styled(Button)`
  margin-left: 1rem;
`;
